const Utils = require('./utils');

// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
/* const trim = text => {
    const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    return !text ? '' : (text + '').replace(rtrim, '');
};*/

const spanizeWords = (text, nestingNum = 1) => {
    let inS = '<span class="word-wrap-root">';
    let outS = '</span>';
    let i;
    for (i = 1; i < nestingNum; i++) {
        inS += '<span>';
        outS += '</span>';
    }

    let outputHtml = inS;
    outputHtml += text.replace(/\s/g, outS + '&nbsp;' + inS);
    outputHtml += outS;
    return outputHtml;
};

const spanizeText = (text, nestingNum = 1) => {
    if (text.length < 1) return '';

    let spanizer = [];
    let inS = '<span class="symbol-wrap-root">';
    let outS = '</span>';
    let i;
    for (i = 1; i < nestingNum; i++) {
        inS += '<span>';
        outS += '</span>';
    }

    while (text.length > 0) {
        const arr = text.match(/&[A-Za-z]+\w+;/);
        if (!arr) break;
        if (arr.index > 0) spanizer = spanizer.concat(text.substr(0, arr.index).split(''));
        spanizer.push(arr[0]);
        text = text.substr(arr.index + arr[0].length);
    }
    spanizer = spanizer.concat(text.split(''));
    spanizer = spanizer.map(s => {
        if (s === ' ') return '&nbsp;';
        return s;
    });

    return inS + spanizer.join(outS + inS) + outS;
};

const _wrapSymbols = (container, settings) => {
    let inputHtml = container.innerHTML;
    let outputHtml = '';
    const chs = container.children;
    let ch;
    let n;
    let s;
    for (let i = 0; i < chs.length; i++) {
        ch = chs[i];
        s = ch.outerHTML;
        n = inputHtml.search(s);
        if (n > -1) {
            if (n > 0) outputHtml += spanizeText(inputHtml.substr(0, n), settings.nestingNum);
            inputHtml = inputHtml.substr(n + s.length);
            _wrapSymbols(ch, settings);
        }
        outputHtml += ch.outerHTML;
    }
    outputHtml += spanizeText(inputHtml.substr(0, n), settings.nestingNum);
    container.innerHTML = outputHtml;
};

const _wrapWords = (container, settings) => {
    let inputHtml = container.innerHTML;

    let outputHtml = '<span class="line-wrap-root">';
    const chs = container.children;
    let ch;
    let n;
    let s;
    let name;
    for (let i = 0; i < chs.length; i++) {
        ch = chs[i];
        name = ch.nodeName.toUpperCase();

        s = ch.outerHTML;
        n = inputHtml.search(s);
        if (n > -1) {
            if (n > 0) outputHtml += spanizeWords(inputHtml.substr(0, n));
            inputHtml = inputHtml.substr(n + s.length);
        }

        switch (name) {
            case 'BR':
                outputHtml += '</span><span class="line-break"></span><span class="line-wrap-root">';
                break;
            default:
                _wrapSymbols(ch, settings);
                outputHtml += ch.outerHTML;
                break;
        }
    }
    outputHtml += spanizeWords(inputHtml.substr(0, n));
    outputHtml += '</span>';
    container.innerHTML = outputHtml;
};

const defaults = {
    cssProperty: 'animation',
    delay: 0,
    factor: 2,
    delayRatio: 0.4,
    delayMax: 0.02,
    delayMin: 0.015,
    durationRatio: 0.2,
    durationMax: 0.45,
    durationMin: 0.3,
    reverse: false,
    center: false,
    nestingNum: 1,
    applyTiming: true,
    flowType: 'line',
    timingNestingLevel: 0
};

const applyTiming = (elems, params) => {
    if (!elems || elems.length < 1) return;

    let selector = '.symbol-wrap-root';

    let i;
    const n = Math.min(params.timingNestingLevel, params.nestingNum - 1);
    for (i = 0; i < n; i++) {
        selector += ' span';
    }

    elems.forEach(el => {
        let ss = [...el.querySelectorAll(selector)];
        let num;
        let s;
        let ssp;

        if (params.reverse) ss = ss.reverse();
        if (params.center) {
            ssp = ss.splice(0, Math.floor(ss.length / 2));
            if (params.reverse) ss = ss.reverse();
            else ssp = ssp.reverse();
        }

        num = ss.length;

        const d0 = params.delayMax;
        const dmin = params.delayMin;
        const r = params.durationRatio;
        const a = ((d0 - dmin) * params.factor) / (r * r * num * num);

        const t0 = params.durationMax;
        const tmin = params.durationMin;
        const r2 = params.durationRatio;
        const b = ((t0 - tmin) * params.factor) / (r2 * r2 * num * num);

        let delay = 0;
        for (let i = 0; i < num; i++) {
            s = ss[i];

            delay += a * (i - r * num) * (i - r * num) + dmin;

            s.parentNode.classList.add('symbol-wrap-root--left');
            s.setAttribute(
                'style',
                `${params.cssProperty}-duration: ${b * (i - r2 * num) * (i - r2 * num) + tmin}s; ${params.cssProperty}-delay: ${params.delay + delay}s`
            );
        }

        if (!ssp) return;

        delay = 0;
        ss = ssp;
        num = ss.length;
        for (let i = 0; i < num; i++) {
            s = ss[i];

            delay += a * (i - r * num) * (i - r * num) + dmin;

            s.parentNode.classList.add('symbol-wrap-root--right');
            s.setAttribute(
                'style',
                `${params.cssProperty}-duration: ${b * (i - r2 * num) * (i - r2 * num) + tmin}s; ${params.cssProperty}-delay: ${params.delay + delay}s`
            );
        }
    });
};

module.exports.wrapSymbols = (elems, settings) => {
    const params = Utils.extend({}, defaults, settings);

    elems.forEach(container => {
        _wrapWords(container, params);
        _wrapSymbols(container, params);
    });
    if (params.applyTiming) {
        switch (params.flowType) {
            case 'line':
                elems.forEach(el => {
                    applyTiming([...el.querySelectorAll('.line-wrap-root')], params);
                });
                break;

            case 'word':
                elems.forEach(el => {
                    applyTiming([...el.querySelectorAll('.word-wrap-root')], params);
                });
                break;

            case 'container':
                applyTiming(elems, params);
                break;
        }
    }
};
